import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';

function Testimonials() {
  const testimonials = [
    {
      name: 'JAMES REYNOLDS, III',
      text: 'Thank you so much for your warm hospitality, The hunting and fellowship could not have been better. It was extremely generous of you to allow Ryan and me access to such a beautiful tract of land. You guys certainly have the turkeys and other wildlife. Again, thank everyone for a memorable experience.',
    },
    {
      name: 'Art Medecky',
      text: "For my first paid hunt I couldn't have picked a better place! Thank you Gary and Mel. The hunt was fun, the food was great and the guides were even better. Trophy Georgia Hunts has given me a memory I will never forget.",
    },

    {
      name: 'Harold D. Weston',
      text: "The 4th Joint Support Element gratefully acknowledges you for outstanding contributions to the United States Army. We appreciate your support of soldiers fighting a Global War on Terrorism and are proud to recognize your personal sacrifices in preserving the freedom and security of the nation. Your dedication to our nation's Wounded Warrior Project, disabled, as well as active and reserve components helps bring hope and healing to our heroes as they return from Iraq, Afghanistan and other troubled places around the globe.",
    },
    {
      name: 'Frank',
      text: "I want to thank you for making this an incredible hunting season. I've really enjoyed hunting with you in South Georgia.",
    },
    {
      name: 'Jamie',
      text: 'Thank you so much for your warm hospitality, The hunting and fellowship could not have been better.',
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 10000); // 10 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      id="testimonials-section"
      component="section"
      sx={{
        background:
          'linear-gradient(to Top,rgb(82, 82, 82) 0%,rgb(106, 106, 106) 100%)',
        color: 'white',
        borderRadius: 2,
        p: 4, // Added padding
        mb: 15,
      }}
    >
      <Grid
        container
        item
        flexDirection="column"
        alignItems="center"
        xs={12}
        md={8}
        sx={{ mx: 'auto', textAlign: 'center' }}
      >
        <Typography variant="h1" id="Testimonials" color="black">
          Testimonials
        </Typography>

        <Paper
          elevation={3}
          sx={{
            p: 3,
            mt: 4,
            minWidth: 300,
            maxWidth: 500,
            mx: 'auto',
            background: 'rgba(255,255,255,0.08)',
            color: 'white',
            transition: 'all 0.5s',
          }}
        >
          <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 2 }}>
            "{testimonials[current].text}"
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            - {testimonials[current].name}
          </Typography>
        </Paper>
      </Grid>
    </Box>
  );
}
export default Testimonials;
